import React, { memo } from 'react';

import { BrowserRouter as Router, Route } from 'react-router-dom';
import { NavigationRoutes } from './type';
import { LoginScreen } from '../screens/auth/login';
import { Routes } from '../components/routes/routes';
import { HomeScreen } from '../screens/home/home';
import { RootLayout } from '../components/layout/root-layout';
import { useSelector } from 'react-redux';
import { AuthState } from '../store/reducer/auth';
import { UserSettingsScreen } from '../screens/settings/user';
import { BranchListScreen } from '../screens/branch/list';
import { UserListScreen } from '../screens/user/list';
import { BrandListScreen } from '../screens/brand/list';
import { OptionListScreen } from '../screens/option/list';
import { ModelListScreen } from '../screens/model/list';
import { NotFoundScreen } from '../screens/not-found/not-found';
import { ValuationScreen } from '../screens/valuation';
import { ValuationDetailScreen } from '../screens/valuation/list';
import { ChangePasswordScreen } from '../screens/me/password';
import { PermissionListScreen } from '../screens/permission/list';
import useSWR from 'swr';
import { GeneralApi, UserApi } from '../apis';
import { ValuationTaskScreen } from '../screens/valuation-task';
import { ReportScreen } from '../screens/report';
import { ValuationEditScreen } from '../screens/valuation/edit';
import { ForgotScreen } from '../screens/auth/forgot';
import { OtpScreen } from '../screens/auth/otp';
import { PasswordForm } from '../components/auth/password';
import { NoneCollateralVehicleList } from '../screens/none-collateral-vehicle/list';
import { AppraisalSendValuationScreen } from '../screens/report/appraisal-send-valuation';

const NavigationContainer = memo(() => {
  useSWR('/api/init', GeneralApi.init);
  const { accessToken } = useSelector((state: { auth: AuthState }) => state?.auth);
  const { data: me } = useSWR('/api/user/me', UserApi.me);

  if (!accessToken && !me) {
    return (
      <>
        <Router>
          <Routes>
            <Route path={'*'} element={<LoginScreen />} />
            <Route path={NavigationRoutes.Otp_Screen} element={<OtpScreen />} />
            <Route path={NavigationRoutes.Login_Screen} element={<LoginScreen />} />
            <Route path={NavigationRoutes.Forgot_Screen} element={<ForgotScreen />} />
            <Route path={NavigationRoutes.Password_Screen} element={<PasswordForm />} />
            {/* Otp_Screen */}
          </Routes>
        </Router>
      </>
    );
  }

  return (
    <>
      <div>
        <Router>
          <RootLayout>
            <Route path={NavigationRoutes.Home_Screen} element={<HomeScreen />} />
            <Route path={NavigationRoutes.Branch_Screen} element={<BranchListScreen />} />
            <Route path={NavigationRoutes.User_Settings_Screen} element={<UserSettingsScreen />} />
            <Route path={NavigationRoutes.Brand_ListScreen} element={<BrandListScreen />} />
            <Route path={NavigationRoutes.User_ListScreen} element={<UserListScreen />} />
            <Route path={NavigationRoutes.Model_ListScreen} element={<ModelListScreen />} />
            <Route path={NavigationRoutes.Option_ListScreen} element={<OptionListScreen />} />
            <Route
              path={NavigationRoutes.Permission_listScreen}
              element={<PermissionListScreen />}
            />

            <Route path={NavigationRoutes.Task_Report_Screen + '/:id'} element={<ReportScreen />} />

            <Route path={NavigationRoutes.Valuation_ListScreen} element={<ValuationTaskScreen />} />

            <Route
              path={NavigationRoutes.User_Password_ChangeScreen}
              element={<ChangePasswordScreen />}
            />

            <Route path={NavigationRoutes.ValuationScreen} element={<ValuationScreen />} />
            <Route path={NavigationRoutes.ValuationEditScreen} element={<ValuationEditScreen />} />

            {/* <Route
              path={NavigationRoutes.Valuation_ListScreen}
              element={<ValuationDetailScreen />}
            /> */}

            <Route
              path={NavigationRoutes.Settings_NoneCollateralVehicle_Screen}
              element={<NoneCollateralVehicleList />}
            />

            <Route
              path={NavigationRoutes.AppraisalSendValuationScreen}
              element={<AppraisalSendValuationScreen />}
            />

            <Route path="*" element={<NotFoundScreen />} />
          </RootLayout>
          {/* </Routes> */}
        </Router>
      </div>
    </>
  );
});

NavigationContainer.displayName = 'NavigationContainer';

export { NavigationContainer };
